import React from "react";
import { motion } from "framer-motion";

const BodyFatGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">ترکیب بدن</h4>
                <div className="grid grid-cols-2 gap-3 mb-3">
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">۲۱.۳٪</div>
                        <div className="text-xs text-[#9EA3A9]">چربی بدن</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">۶۲.۴٪</div>
                        <div className="text-xs text-[#9EA3A9]">آب بدن</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">۳۸.۷٪</div>
                        <div className="text-xs text-[#9EA3A9]">عضله</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">۳.۱ کیلوگرم</div>
                        <div className="text-xs text-[#9EA3A9]">توده استخوانی</div>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">روند چربی بدن</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 flex items-end shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    {[...Array(12)].map((_, i) => {
                        const height = 70 - i * 1.5 + (Math.random() * 10 - 5);
                        return (
                            <motion.div
                                key={i}
                                className="w-full mx-0.5 rounded-t-[4px] bg-[#32D74B]"
                                initial={{ height: 0 }}
                                animate={{ height: `${height}%` }}
                                transition={{
                                    duration: 0.2,
                                    delay: i * 0.05,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                        );
                    })}
                </div>
                <div className="flex justify-between text-xs text-[#9EA3A9] mt-1">
                    <span>۳ ماه پیش</span>
                    <span>امروز</span>
                </div>
            </div>
        </div>
    );
};

export default BodyFatGraph;
